module.exports = __webpack_public_path__ + "static/media/ico_cake.c070f0c4.svg";